module.exports = __webpack_public_path__ + "img/18101680880697_.pic_thumb.afcbac96.jpg";